import React, { FC, memo } from 'react';
import classNames from 'classnames';

import { TopBannerState } from 'application/components/widgets/TopBanner/useTopBannerState';
import { RouterUtils, useNavigate } from 'application/providers/RouterProvider';
import { BILLING_PAGE_PATH, StateParamValues } from 'application/pages/BillingPage';
import { WHATSAPP_KZ_URL, TELEGRAM_BY_URL } from 'application/utils/CommunicationUtils';
import DeclensionUtils from 'application/utils/DeclensionUtils';

import { Country } from '@shared/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import IconX from '@zvuk-b2b/react-uikit/ui/icons/X';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { TEXTS } from '../texts';

import styles from '../index.module.scss';

const BUTTON_BACKGROUND_IMAGE_PATH = '/assets/img/banner/billing_button_background.png';
const BILLING_PAGE_TO_LINK = RouterUtils.generatePath(BILLING_PAGE_PATH, { state: StateParamValues.INFO });

interface TrialBannerProps {
  className?: string;
  banner: TopBannerState;
  onClose: () => void;
  country: Country;
}

const TrialBanner: FC<TrialBannerProps> = ({ banner, onClose, className, country }) => {
  const navigate = useNavigate();
  const { isDesktop } = useMedia();

  const onPayClick = () => {
    switch (country) {
      case Country.Kz: {
        const link = `${WHATSAPP_KZ_URL}/?text=${TEXTS.BANNER_TRIAL_KZ_MESSAGE_TEXT}`;

        window.open(link, '_blank');

        break;
      }
      case Country.By: {
        window.open(TELEGRAM_BY_URL, '_blank');

        break;
      }
      default: {
        navigate(BILLING_PAGE_TO_LINK);
      }
    }
  };

  return (
    <div
      className={classNames(styles.TopBanner, className)}
      data-type={banner.type}>
      <div className={styles.TopBannerDescription}>
        {country === Country.By ? (
          <div>
            <span>{`${TEXTS.BANNER_TRIAL_BY_COUNTDOWN_TEXT}`}</span>
            <span className={styles.TopBannerDescriptionDays}>
              {`${DeclensionUtils.getFormattedDay(banner.trialDaysLeft || 0)}`}
            </span>
            <span>{TEXTS.BANNER_TRIAL_BY_TEXT}</span>
          </div>
        ) : (
          <div>
            <span>{`${TEXTS.BANNER_TRIAL_TEXT}`}</span>
            <span className={styles.TopBannerDescriptionDays}>
              {`${DeclensionUtils.getFormattedDay(banner.trialDaysLeft || 0)}`}
            </span>
          </div>
        )}
      </div>

      <div className={styles.TopBannerButtonTrialWrapper}>
        {isDesktop && (
          <img
            src={BUTTON_BACKGROUND_IMAGE_PATH}
            alt=""
            loading="lazy"
            className={styles.TopBannerButtonTrialImage}
          />
        )}

        <Button
          elementId="trial_period_banner_button_go_to_billing"
          type={ButtonType.PLAIN}
          className={classNames(styles.TopBannerButton)}
          onClick={onPayClick}>
          {TEXTS.BUTTON_GO_TO_BILLING_VARIANT_TITLE_TRIAL}
        </Button>
      </div>

      <Button
        elementId="button-billing-banner-close"
        className={styles.TopBannerCloseButton}
        onClick={onClose}
        type={ButtonType.PLAIN}>
        <IconX className={styles.TopBannerCloseButtonIcon} />
      </Button>
    </div>
  );
};

export default memo(TrialBanner);
